import { render, staticRenderFns } from "./TemplateBildungsgangliste.vue?vue&type=template&id=3ba48feb&"
import script from "./TemplateBildungsgangliste.vue?vue&type=script&lang=js&"
export * from "./TemplateBildungsgangliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports